//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import ListListEdit from '~/components/List/ListEdit';
import ListEditWeb from './ListEditWeb';
import { cleanObj } from '~/utils';
import { required, email, phone } from '@/utils/validation.js';

export default {
  name: 'Info',
  components: { ListListEdit, ListEditWeb },
  data() {
    return {
      infoData: {},
      rules: {
        email: [required, email],
        phoneNumber: [required, phone],
      },
    };
  },
  computed: {
    ...mapGetters('lecturer', ['teachingFields']),
  },
  methods: {
    ...mapActions('user', [
      'setUserName',
      'setUserEngName',
      'setEmail',
      'setAvatarUrl',
    ]),
    getExperience() {
      this.$api('getLecturerExperience').then(data => {
        this.infoData.lecturerExperienceLt = data;
      });
    },
    getTeachOwner() {
      this.$api('getLecturerTeachOwner').then(data => {
        this.infoData.lecturerTeachOwnerLt = data;
      });
    },
    getPublish() {
      this.$api('getLecturerPublish').then(data => {
        this.infoData.lecturerPublishLt = data;
      });
    },
    getWebsite() {
      this.$api('getLecturerWebsite').then(data => {
        this.infoData.lecturerWebsiteLt = data;
      });
    },
    getInfo() {
      const payload = {};

      this.$api('getLecturer', payload).then(data => {
        this.infoData = data;
      });
    },
    handleInfo() {},
    onSave() {
      this.$refs.infoData.validate(valid => {
        if (!valid) {
          return false;
        }

        let payload = cleanObj(this.infoData);

        this.$api('updateLecturer', payload)
          .then(data => {
            const { name, engName, email } = payload;
            this.setUserName(name);
            this.setUserEngName(engName);
            this.setEmail(email);
            this.getInfo();
            this.$message.success('編輯成功!');
          })
          .catch(error => {
            this.$message.warning(`編輯失敗! ${error.message}`);
          });
      });
    },
    onUploadFile(payload) {
      this.$api('uploadLecturerAvatar', payload, data => {
        this.setAvatarUrl(data);
      });
    },
  },
  mounted() {
    this.getInfo();
  },
};
